module.exports = __webpack_public_path__ + "static/media/player-movein.31141d59.png";